import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import styles from './deleteTasksNotesDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import Delete from '@mui/icons-material/Delete'
import Close from '@mui/icons-material/Close'
import { useMutation } from '@apollo/client'
import { DELETE_TASK_NOTE } from '@/modules/API/taskNote/taskNoteHandler.ts'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface DeleteTasksNoteDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    taskNoteId: number
    handleRefetch: () => void
}

const DeleteTasksNoteDialog: FunctionComponent<DeleteTasksNoteDialogProps> = ({
    open,
    handleClose,
    daycareId,
    taskNoteId,
    handleRefetch
}: DeleteTasksNoteDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteTaskNote, { loading: deleteTaskNoteLoading }] = useMutation(DELETE_TASK_NOTE, {
        variables: {
            daycareId,
            taskNoteId
        },
        onCompleted: () => {
            handleRefetch()
            handleClose()

            showNotificationSuccess(t('taskNoteDeleted'))
        },
        onError: () => {
            showNotificationError(t('taskNoteDeletedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.DialogBody}>
            <DialogHeader title={t('deleteTaskNote')} />
            <DialogBody>
                <div className={styles.DialogContainer}>
                    <p className={styles.Text}>{t('deleteConfirmTaskNote')}</p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Delete />}
                        customText={t('yes')}
                        onClick={deleteTaskNote}
                        className={styles.Button}
                        disabled={deleteTaskNoteLoading}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Close />}
                        customText={t('no')}
                        onClick={handleClose}
                        className={styles.Button}
                        disabled={deleteTaskNoteLoading}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DeleteTasksNoteDialog
